import SearchBadge from './SearchBadge';

export default SearchBadge;



// WEBPACK FOOTER //
// ./src/components/SolicitationsSearchBar/subComponents/SearchBadge/index.jsx